/* eslint-disable react/no-unused-prop-types */
import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {connect} from '@stubhub/react-store-provider';

import MapToDataLayer from './map-to-datalayer';
class ReduxStoreTracker extends Component {
  static propTypes = {
    storeKey: PropTypes.string.isRequired, // StoreKey that maps redux[storeKey] -> datalayer[storeKey]
    reducer: PropTypes.func, // Reducer allows you to intercept the data and mutate before it's put on datalayer[storeKey]
    when: PropTypes.func, // Only place data on datalayer[storeKey] if when condition is met
  };

  // Simple empty child to be wrapped by `connect` HOC and mounted on react layer
  ConnectedComp = _withStoreMapper(this.props);

  render() {
    const Comp = this.ConnectedComp;

    return <Comp />;
  }
}

const defaultWhen = () => true;
const defaultReducer = (state, {__reset__, ...otherData}) => otherData;

function _withStoreMapper({storeKey, reducer = defaultReducer, when = defaultWhen}) {
  return connect({
    mapStateToProps(state) {
      const dataAtStoreKey = state[storeKey] || {};
      if (when(dataAtStoreKey)) {
        return {dataKey: storeKey, data: reducer(state, dataAtStoreKey)};
      }

      return {dataKey: storeKey};
    },
  })(MapToDataLayer);
}

export default ReduxStoreTracker;
